<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-5">Duomenų teikėjas</h3>
    <div class="dataContainer">
      <v-row>
        <v-col cols="12" md="6" v-if="showSelect">
          <el-autocomplete
            :items="teikejasList"
            itemvalue="asm_asmens_kodas"
            itemtext="asm_pavadinimas"
            return-object
            :label="tekstas.teikejas"
            :tooltip="`${tooltipPrefix}${tekstas.teikejasTooltip}`"
            :readonly="hipotekaReadonly"
            v-model="formData"
          />
        </v-col>
        <v-col cols="12" md="6" v-if="showAddAsmuo">
          <el-button-prideti
            v-if="roleRG && !hipotekaReadonly"
            class="mt-3"
            @click.native.stop="openAsmuo(null)"
          >
            Pridėti asmenį
          </el-button-prideti>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <el-text-field
            :label="tekstas.vardas"
            :tooltip="`${tooltipPrefix}${tekstas.vardasTooltip}`"
            :readonly="!editAsmuo"
            v-model="formData.asm_fiz_vardas"
          />
        </v-col>
        <v-col cols="12" md="6">
          <el-text-field
            :label="tekstas.pavarde"
            :tooltip="`${tooltipPrefix}${tekstas.pavardeTooltip}`"
            :readonly="!editAsmuo"
            v-model="formData.asm_fiz_pavarde"
          />
        </v-col>
        <v-col cols="12" md="12">
          <el-text-field
            v-if="showPareigos"
            :label="tekstas.pareigos"
            :tooltip="`${tooltipPrefix}${tekstas.pareigosTooltip}`"
            :readonly="!editPareigos"
            v-model="formData.asm_jur_stat_pavad"
          />
        </v-col>
        <v-col cols="12" md="12">
          <el-text-field
            v-if="showKontora"
            :label="tekstas.kontora"
            :tooltip="`${tooltipPrefix}${tekstas.kontoraTooltip}`"
            :readonly="!editAsmuo"
            v-model="formData.asm_kontora"
          />
        </v-col>
        <v-col cols="12" md="12">
          <el-text-field
            :readonly="!editAsmuo"
            :label="tekstas.adresas"
            :tooltip="`${tooltipPrefix}${tekstas.adresasTooltip}`"
            v-model="formData.adr_text"
          />
        </v-col>
      </v-row>
    </div>

    <hipoteka-istorija duomenys="duomenu-teikejas" />

    <modal-asmuo
      :key="modalAsmuoKey"
      v-model="showAsmuo"
      :asmuo="modalAsmuo"
      :asmuo-role="asmuoRole"
      :salys="salys"
      @savedData="savedAsmuo"
    />

    <v-footer class="form-footer">
      <el-button
        v-if="!hipotekaReadonly && !isSavitarna"
        primary
        @click.native="saveData()"
        :loading="loading"
        >Saugoti</el-button
      >
      <el-button
        v-if="!hipotekaReadonly && !isSavitarna"
        @click.native="cancelData()"
        :loading="loading"
        >Atšaukti</el-button
      >
      <v-spacer></v-spacer>
      <el-button
        v-if="!hipotekaReadonly"
        primary
        @click.native="checkErrorsClick()"
        :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './hipotekaMap'
import userRole from '../../mixins/userRole'
import busena from '../../mixins/busena'
import unsavedData from '../../mixins/unsavedData'
import checkErrors from '../../mixins/checkErrors'
import HipotekaIstorija from './istorija/HipotekaIstorija'
import ModalAsmuo from '../modals/ModalAsmuo'

export default {
  name: 'HipotekaTeikejas',
  components: {
    HipotekaIstorija,
    ModalAsmuo,
  },
  mixins: [unsavedData, checkErrors, userRole, busena],
  data() {
    return {
      formData: {
        sasm_kontora_tipas: null,
      },
      pageloading: true,
      loading: true,
      teikejai: [],
      showAsmuo: false,
      modalAsmuoKey: 'asmuo',
      modalAsmuoRefresh: 0,
      modalAsmuo: {},
      salys: [],
    }
  },
  computed: {
    ...mapGetters([
      'userKontoraTipas',
      'objektasID',
      'hipotekaTipas',
      'hipotekaReadonly',
      'appSavitarna',
    ]),
    teikejasList() {
      return this.teikejai.map(item => {
        return item
      })
    },
    isTeikejasList() {
      return this.teikejasList.length > 1
    },
    asmuoRole() {
      return 'teikejas'
    },
    kontoraTipas() {
      let tipas = parseInt(
        this.formData.sasm_kontora_tipas ?? this.userKontoraTipas
      )

      switch (tipas) {
        case 13:
          return 'notaras'
        case 5:
          return 'antstolis'
        default:
          return 'kita'
      }
    },
    isSutartis() {
      return this.hipotekaTipas.includes('sutartis')
    },
    isNotaras() {
      return this.kontoraTipas === 'notaras' || true
    },
    isAntstolis() {
      return this.kontoraTipas === 'antstolis'
    },
    isSavitarna() {
      return this.appSavitarna
    },
    tekstas() {
      return HipotekaMap['teikejasTekstas'][this.kontoraTipas] ?? {}
    },
    tooltipPrefix() {
      return this.isSutartis ? 'Sutartis. ' : 'Hipoteka. '
    },
    showSelect() {
      return (
        (this.isNotaras || this.isAntstolis) &&
        this.isTeikejasList &&
        !this.isSavitarna
      )
    },
    showAddAsmuo() {
      return this.roleRG && this.isRengiamas
    },
    editAsmuo() {
      return (
        this.roleRG &&
        this.isRengiamas &&
        this.formData.amn_id > 0 &&
        !this.hipotekaReadonly
      )
    },
    editPareigos() {
      return (
        this.roleOr(['DT_notaras', 'DT_notaro_atstovas']) &&
        (this.isRengiamas || this.isGrazintas) &&
        this.formData.amn_id > 0 &&
        !this.hipotekaReadonly
      )
    },
    showPareigos() {
      return !this.isSavitarna
    },
    showKontora() {
      return !this.isSavitarna || this.formData.sasm_kontora_tipas !== null
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`objektas/${this.objektasID}/teikejas`)
        .then(res => {
          this.teikejai = res.data.list
          if (
            this.teikejai.length == 1 &&
            !this.hipotekaReadonly &&
            !this.isSavitarna
          ) {
            this.formData = this.teikejai[0]
          } else {
            this.formData = res.data.teikejas ?? {}
          }
          this.salys = res.data.salys
          this.initialForm()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(toRoute, afterSave) {
      this.loading = true
      const data = {
        teikejas: this.formData ? this.formData.amn_id : null,
        ...this.formData,
      }
      this.$axios
        .post(`objektas/${this.objektasID}/teikejas`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          if (toRoute) {
            this.goToRoute()
          } else {
            this.initialForm()
            if (afterSave === 'checkErrors') {
              this.checkErrors()
            }
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelData() {
      this.getData()
    },
    openAsmuo(sasm_id) {
      this.modalAsmuo = {
        sasm_id: sasm_id,
      }
      this.modalAsmuoKey =
        'asmuo' + (sasm_id ?? 'new' + this.modalAsmuoRefresh++)
      this.showAsmuo = true
    },
    savedAsmuo(modalAsmuo) {
      if (modalAsmuo.tipas === 'FIZ') {
        this.formData = {
          amn_id: modalAsmuo.amn_id,
          asm_fiz_vardas: modalAsmuo.asm_fiz_vardas,
          asm_fiz_pavarde: modalAsmuo.asm_fiz_pavarde,
          asm_jur_stat_pavad: '',
          asm_kontora: '',
          adr_text: modalAsmuo.adresas.text,
        }
      } else {
        this.formData = {
          amn_id: modalAsmuo.amn_id,
          asm_fiz_vardas: '',
          asm_fiz_pavarde: '',
          asm_jur_stat_pavad: '',
          asm_kontora: modalAsmuo.asm_pavadinimas,
          adr_text: modalAsmuo.adresas.text,
        }
      }
      this.showAsmuo = false
    },
    checkErrorsClick() {
      if (this.isSavitarna) {
        this.checkErrors()
        return
      }
      this.saveData(null, 'checkErrors')
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
</style>
